// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledDesktopPopover = styled('div')(
  () => css`
    .desktop-size-modal {
      .info {
        padding: 20px;
      }

      .label {
        margin-right: 10px;
        font-weight: bold;
        white-space: nowrap;
      }

      .section {
        font-weight: bold;
        font-size: 0.875rem;
        color: #6c879b;
        padding: 16px;
        cursor: pointer;
      }

      .avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #eeeef2;
        border: 1px solid #e2e2ea;
      }
    }

    @media only screen and (max-width: 1095px) {
      .desktop-size-modal {
        display: none;
      }
    }
  `
);
